import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ApplicationError } from "../../components/ApplicationStatus/ApplicationError";
import { Providers } from "./components/Providers";
import { MobileNotification } from "../../components/Notifications";
import { FormLayoutComponent } from "./components/FormLayoutComponent";
import { ERROR_MESSAGES } from "../../constants";
import { ERRORS_TYPE } from "../../utils/getErrorScreenIcons/constants";
import { getErrorScreensIcons } from "../../utils/getErrorScreenIcons/getErrorScreenIcons";
import { Header } from "../../components/Header";
import { useDisableBrowserBackClick } from "../../utils/useDisableBrowserBackClick";

export const FormLayoutContainer = ({
  children,
  screeningError,
  accountType,
  isIslamicBanking,
  errorCode
}) => {
  const { pathname } = useLocation();
  const [isLandingPage, setIsLandingPage] = useState(false);
  const { showDialogForBrowserBackDisabled } = useDisableBrowserBackClick();

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLandingPage(pathname === "/business" || pathname === "" || pathname === "/");
  }, [pathname]);

  return (
    <>
      <Providers>
        <MobileNotification>
          <>
            {/* dialog to show when browser back is clicked */}
            {showDialogForBrowserBackDisabled}
            {!screeningError.error && (
              <>
                {!isLandingPage && <Header />}
                <FormLayoutComponent
                  errorCode={errorCode}
                  errorIcon={getErrorScreensIcons(
                    accountType,
                    isIslamicBanking,
                    ERRORS_TYPE.BLOCK_EDITING
                  )}
                  pathname={pathname}
                  screeningError={screeningError}
                >
                  {children}
                </FormLayoutComponent>
              </>
            )}
            {screeningError.error ? (
              <ApplicationError {...screeningError} />
            ) : (
              errorCode && <ApplicationError text={ERROR_MESSAGES[errorCode]} />
            )}
          </>
        </MobileNotification>
      </Providers>
    </>
  );
};
